import { CuriosityTranslation } from '@procureai/curiosity-ui-mui';

import { SupplierContactData } from '../SupplierContactEditDialog/components/SupplierContactEditForm/SupplierContactEditForm.schema.ts';

import { SupplierContactEntity, SupplierContactHitId } from './SupplierContactAutocomplete.types.ts';

export const createStaticHit = (
  id: SupplierContactHitId,
  value: string,
  key?: string,
): CuriosityTranslation<SupplierContactEntity> => ({
  id,
  key: key ?? id,
  value: value,
  language: '',
  entity: {
    firstName: '',
    lastName: '',
    preferredLanguage: '',
    sourceReference: '',
    email: '',
    roles: [],
  },
});

export const createHitFromEditData = (data: SupplierContactData): CuriosityTranslation<SupplierContactEntity> => ({
  id: data.internalId,
  key: data.internalId,
  value: `${data.firstName} ${data.lastName} <${data.email}>`,
  language: undefined as any, // will be set by the updateCache function properly
  entity: {
    firstName: data.firstName,
    lastName: data.lastName,
    preferredLanguage: data.language,
    email: data.email,
    roles: [data.role],
  },
});
